import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TITLE_INHERIT_STYLE } from "@constants";
import "./css/CurrentOrder.scss";
import { useOrderList } from "./hook/useOrderList";
import { OrderItemList } from "./OrderItemList";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    isHomePage?: boolean;
}

export const CurrentOrder = (props: IParams) => {
    const { orderList, getOrdersState, getOrders } = useOrderList();
    const { isHomePage } = props;
    const { t } = useTranslation("order");

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getOrders, []);

    const displayOffer = !isHomePage || orderList.length !== 0;

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <Fragment>
            {displayOffer && (
                <Card className="order-container" elevation={2}>
                    <CardHeader
                        className="card-header card-header__right"
                        title={t("myCurrentOrder")}
                        titleTypographyProps={TITLE_INHERIT_STYLE}
                    />
                    <CardContent>
                        <div className="card-header__circle" />
                        <HandleErrorAndLoading isLoading={getOrdersState.isLoading}>
                            {orderList.map((order, index) => (
                                <Fragment key={order.reference}>
                                    <OrderItemList offerList={order.offers} order={order} />
                                    {orderList.length !== index + 1 && (
                                        <Grid className="order-card__divider" item xs={12}>
                                            <Divider variant="fullWidth" />
                                        </Grid>
                                    )}
                                </Fragment>
                            ))}
                            {orderList.length === 0 && (
                                <Grid alignContent="center" container direction="column">
                                    <Typography color="secondary" variant="h5">
                                        {t("noOrders")}
                                    </Typography>
                                </Grid>
                            )}
                        </HandleErrorAndLoading>
                    </CardContent>
                </Card>
            )}
        </Fragment>
    );
};
